// extracted by mini-css-extract-plugin
export default {"error":"T6507WLydAGZS154qwCd","textarea":"Xi4OSTV_4OpsR19N_x1B"};